import {useSelector} from 'react-redux';
import LetterBox from '../../components/LetterBox';
import './index.scss';

const WordsCartridge = () => {
    const collectedLetters = useSelector((state) => state.collectedLetters);

    return (
        <div className="words-cartridge">
            {collectedLetters.map((letter, index) => {
                return <LetterBox className="trail-letter" key={letter.id} letter={letter.value} collected={true} />;
            })}
        </div>
    );
};

export default WordsCartridge;
